/**
 * Tutorial 
 * https://stackoverflow.com/a/50953998
 */
import React, { Component, createContext } from "react";
import _ from "lodash"

const { Provider, Consumer } = createContext();

class FancyboxContext extends Component {
  render() {
    return (
      <Provider value={this.props.fancybox}>
          {this.props.children}
      </Provider>
    );
  }
}

export { FancyboxContext };

export default Consumer;